var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card system-tabs"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"heading-elements"},[_c('ul',{staticClass:"tabs-wrapper"},_vm._l((_vm.tabs),function(tab){return _c('page-tab',{key:tab.id,attrs:{"tab":tab}})}),1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }